"use client";

import { SaleTag as ReactBookmarkTag } from "./SaleTag";

export const BookmarkTag = ReactBookmarkTag;
